/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Tc_Id_LabelInputs */

const fr_vehicle_action_edit_tc_id_label = /** @type {(inputs: Vehicle_Action_Edit_Tc_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant TC-Infos`)
};

const en_vehicle_action_edit_tc_id_label = /** @type {(inputs: Vehicle_Action_Edit_Tc_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC-Infos identifier`)
};

/**
* | output |
* | --- |
* | "TC-Infos identifier" |
*
* @param {Vehicle_Action_Edit_Tc_Id_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_tc_id_label = /** @type {((inputs?: Vehicle_Action_Edit_Tc_Id_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Tc_Id_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_tc_id_label(inputs)
	return en_vehicle_action_edit_tc_id_label(inputs)
});